import { Route } from 'vue-router';

export const buildServerUrlPath = (routeValue: Route) => {
  const { serverId, productKey, regionPrefix } = routeValue.params;

  return `${regionPrefix}/server/${productKey}/${serverId}`;
};
